export default function CoursesIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width={`1em`}
        height={`1em`}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0002 11.25C15.0002 12.6479 15.0002 13.3467 14.7718 13.898C14.4673 14.6331 13.8833 15.2171 13.1482 15.5216C12.5969 15.75 11.8979 15.75 10.5002 15.75H8.25015C5.42174 15.75 4.00751 15.75 3.12883 14.8713C2.25015 13.9926 2.25016 12.5784 2.25018 9.74992L2.25023 5.24987C2.25024 3.59308 3.59334 2.25 5.25013 2.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.50015 6.375L7.82543 9.35167C7.85648 9.60052 8.0094 9.81742 8.2398 9.91642C8.7543 10.1374 9.7179 10.5 10.5002 10.5C11.2825 10.5 12.2461 10.1374 12.7606 9.91642C12.991 9.81742 13.1439 9.60052 13.175 9.35167L13.5002 6.375M15.3752 5.625V8.4519M10.5002 3L5.25018 5.25L10.5002 7.5L15.7502 5.25L10.5002 3Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}
